import { AdminReservation } from "./adminReservation";
export class AdminReservationPremium extends AdminReservation {
}
//# sourceMappingURL=adminReservationPremium.js.map